module.exports = __webpack_public_path__ + "assets/images/bd916d35138b68f98f2d7880b37ac45d.png";